import Chip from '@mui/material/Chip';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import { ElectionStatus } from '../../MyElections/helper';

interface ElectionStatusFilterProps {
  value: string;
  onChange: (value: string | null) => void;
  counts: {
    all: number;
    future: number;
    active: number;
    finished: number;
  };
}

export function ElectionStatusFilter({ value, onChange, counts }: ElectionStatusFilterProps) {
  const { t } = useTranslation();

  const options: { value: ElectionStatus | 'all'; label: string }[] = [
    { value: 'all', label: t(translations.pages.polyas.status.all()) },
    { value: 'active', label: t(translations.pages.polyas.status.active()) },
    { value: 'future', label: t(translations.pages.polyas.status.planned()) },
    { value: 'finished', label: t(translations.pages.polyas.status.finished()) }
  ];

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_, newValue) => {
        if (newValue !== null) {
          if (newValue === 'all') {
            onChange(null);
          } else {
            onChange(newValue);
          }
        }
      }}
      size="small"
      sx={{
        justifyContent: 'space-between'
      }}
    >
      {options.map(option => (
        <ToggleButton
          key={option.value}
          value={option.value}
          sx={{
            px: 2,
            gap: 1,
            textTransform: 'none'
          }}
        >
          {option.label}
          <Chip
            label={counts[option.value]}
            size="small"
            sx={{
              height: 20,
              fontSize: '0.75rem',
              bgcolor: 'primary.selected',
              color: value === option.value ? 'white' : '#5B646F'
            }}
          />
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
